import { TierBenefit } from '@mc/api'
import { TFunction, Trans } from '@mc/i18n'
import { PlansTier } from '../../types/planProducts'

export type TransProps = React.ComponentProps<typeof Trans>
export type Benefits = `${TierBenefit['name']}`

export const getTranslationResources = ({
  tier,
  name,
  defaultValue,
  i18nKey: _i18nKey,
  values: _values,
}: {
  tier: PlansTier
  name: Benefits
  defaultValue?: string | number | boolean
  i18nKey: TransProps['i18nKey'] // Parameters<TFunction>['0']
  values: Parameters<TFunction>['2']
}) => {
  let value = getBenefitValue(tier, name)

  if (typeof value === 'undefined') {
    if (typeof defaultValue !== 'undefined') {
      value = defaultValue
    } else {
      return {}
    }
  }

  let i18nKey = _i18nKey
  const values: Record<string, unknown> = _values || {}
  if (typeof value === 'number') {
    values.count = value
  } else if (typeof value === 'boolean' && typeof i18nKey === 'string') {
    i18nKey = `${i18nKey}_${value.toString()}`
  } else {
    values.benefit = value
  }

  return { i18nKey, values }
}

const getBenefitValue = (tier: PlansTier, benefitName: TierBenefit['name']) => {
  const { value } =
    tier.entitlement?.benefits?.find(
      (benefit) => benefit.name === benefitName,
    ) || {}

  return value
}
